/*
  Portami: Link «Datenschutzeinstellungen» im Footer.
  Öffnet die Einstellungen von Shopifys nativem Cookie-Banner (privacyBanner.showPreferences).
  Der Link bleibt verborgen, solange der Banner im Admin (Einstellungen › Kundendatenschutz)
  nicht aktiviert ist, damit kein toter Link erscheint.
*/
(function () {
  function api() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'
      ? window.privacyBanner
      : null;
  }

  function open(event) {
    event.preventDefault();
    var banner = api();
    if (!banner) return;
    var result = banner.showPreferences();
    if (result && typeof result.catch === 'function') {
      result.catch(function () {});
    }
  }

  function init() {
    var links = document.querySelectorAll('[data-portami-privacy]');
    if (!links.length) return;

    function reveal() {
      if (!api()) return false;
      links.forEach(function (link) {
        if (link.dataset.portamiBound) return;
        link.dataset.portamiBound = 'true';
        link.hidden = false;
        link.addEventListener('click', open);
      });
      return true;
    }

    if (reveal()) return;
    // Shopify lädt das Banner-Script asynchron: eine Weile nachprüfen, dann aufgeben.
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (reveal() || tries > 60) window.clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
